/*LIBRARY*/
import React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import centroid from "@turf/centroid";

/*COMPONENT*/
// import CHART_TEMPLATE from "../viewer_chart/CHART_TEMPLATE";
import TOOLBOX_DETAIL_DISTANCE from "./TOOLBOX_DETAIL_DISTANCE";
import TOOLBOX_DETAIL_ELEVATION from "./TOOLBOX_DETAIL_ELEVATION";
import TOOLBOX_DETAIL_AREA from "./TOOLBOX_DETAIL_AREA";
import TOOLBOX_DETAIL_RADIUS from "./TOOLBOX_DETAIL_RADIUS";
import TOOLBOX_DETAIL_ISOCHRONE from "./TOOLBOX_DETAIL_ISOCHRONE";
import TOOLBOX_GRID from "./TOOLBOX_GRID";
import TOOLBOX_RIVER_SCHEMA from "./TOOLBOX_RIVER_SCHEMA";
import GAP_TOOL from "./GAP_TOOL";

/*REDUX*/
import {
  set_value_toolbox,
  change_radius,
  push_value_toolbox,
  status_toolbox,
  generate_isochrone,
} from "../../App/actions/toolboxActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { set_value_sini } from "../../App/actions/sini_v2";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/

/*FUNCTION*/
import is_not_empty from "../../App/validation/is_not_empty";
import generate_uuid from "../../App/validation/generate_uuid";

/*DATA*/
import st_colors from "../../Data/twenty_colors.json";
import dict from "../../Data/dict.json";
import { domain_bbws_maluku_river_schema } from "../../App/validation/features_domain";
import TOOLBOX_SELECTION from "./TOOLBOX_SELECTION";
import { get_toolbox_mode_list } from "../../App/validation/toolbox_mode_list";
import { get_list_tipe_1, get_list_tipe_2, get_list_tipe_3 } from "../../App/actions/insight_v2";
import TOOLBOX_DETAIL_ROUTING from "./TOOLBOX_DETAIL_ROUTING";

/*CONST*/

class TOOLBOX_TABLE extends Component {
  state = {
    modal_default_radius: false,
    selected_uuid: " ",
    option_isokron: { status: false, id: "" },
    data_new_isokron: {
      isochrone_profile: "driving",
      contour_type: "minutes",
      contours_minutes: "10",
      contours_meters: 0,
      distance: false,
    },
  };

  componentDidMount = () => {
    const { list_tipe_1, list_tipe_2, list_tipe_3 } = this.props.insight_reducer || {};

    if (list_tipe_1.length === 0) {
      this.props.get_list_tipe_1();
    }
    if (list_tipe_2.length === 0) {
      this.props.get_list_tipe_2();
    }
    if (list_tipe_3.length === 0) {
      this.props.get_list_tipe_3();
    }
  }

  on_draw = () => {
    //state management draw
    this.props.set_value_layer({
      key: "draw_state_platform",
      value: "toolbox",
    });
    this.props.set_value_layer({
      key: "geometryStatus",
      value: false,
    });
    const { mode_toolbox } = this.props.toolbox;
    let tool = get_toolbox_mode_list(mode_toolbox)
    const mode_draw = tool?.mode;
    this.props.set_value_toolbox({
      key: "mode_draw",
      value: mode_draw,
    });
    this.props.status_action();

    //bagian map
    const { map_object } = this.props.layer;
    const draw_object = this.props.layer.draw_object;

    if (map_object && mode_draw && draw_object) {
      map_object.getCanvas().style.cursor = "crosshair";
      draw_object.changeMode(mode_draw);
    }
  };

  toggle_default_radius = () => {
    this.setState({ modal_default_radius: !this.state.modal_default_radius });
    this.props.set_value_toolbox({
      key: "uuid_radius",
      value: "",
    });
  };

  on_change_radius = (e) => {
    const id = e.target.id;
    const name = e.target.name;
    const value = e.target.value;
    const body = {
      uuid: id,
      key: name,
      value: value,
    };
    this.props.change_radius(body);
    this.props.status_toolbox();
  };

  on_change_props = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "default_radius_m" || name === "default_radius_km") {
      let default_radius_km, default_radius_m;
      let { features_radius } = this.props.toolbox;
      if (is_not_empty(value)) {
        if (name === "default_radius_m") {
          default_radius_m = parseFloat(value) || 0;
          default_radius_km = parseFloat(value / 1000) || 0;
        } else if (name === "default_radius_km") {
          default_radius_km = parseFloat(value) || 0;
          default_radius_m = parseFloat(value * 1000) || 0;
        }
        features_radius = features_radius.map((item) => {
          item.properties.radius_km = default_radius_km;
          item.properties.radius_m = default_radius_m;
          return item;
        });

        this.props.set_value_toolbox({
          key: "default_radius_m",
          value: default_radius_m,
        });
        this.props.set_value_toolbox({
          key: "default_radius_km",
          value: default_radius_km,
        });
        this.props.set_value_toolbox({
          key: features_radius,
          value: features_radius,
        });
      }
    }
  };

  on_delete_item = (uuid) => {
    //remover marker by DOM
    const marker_to_remove = document.getElementById(`marker_toolbox_${uuid}`);
    if (marker_to_remove) {
      marker_to_remove.remove();
    }

    const { mode_toolbox } = this.props.toolbox;
    let features = this.props.toolbox[mode_toolbox];
    const { status, id } = this.state.option_isokron;
    features = features.filter((item) => item.properties.uuid !== uuid);
    this.props.set_value_toolbox({
      key: mode_toolbox,
      value: features,
    });

    if (mode_toolbox === "features_elevation") {
      let { features_elevation_point, features_elevation_center } =
        this.props.toolbox;
      features_elevation_point = features_elevation_point.filter(
        (item) => item.properties.parent_uuid !== uuid
      );
      features_elevation_center = features_elevation_center.filter(
        (item) => item.properties.uuid !== uuid
      );
      this.props.set_value_toolbox({
        key: "features_elevation_point",
        value: features_elevation_point,
      });
      this.props.set_value_toolbox({
        key: "features_elevation_center",
        value: features_elevation_center,
      });
    } else if (mode_toolbox === "features_distance") {
      let { features_distance_label, features_distance_center } =
        this.props.toolbox;
      features_distance_label = features_distance_label.filter(
        (item) => item.properties.parent_uuid !== uuid
      );
      features_distance_center = features_distance_center.filter(
        (item) => item.properties.uuid !== uuid
      );
      this.props.set_value_toolbox({
        key: "features_distance_label",
        value: features_distance_label,
      });
      this.props.set_value_toolbox({
        key: "features_distance_center",
        value: features_distance_center,
      });
    } else if (mode_toolbox === "features_area") {
      let { features_area_center } = this.props.toolbox;
      features_area_center = features_area_center.filter(
        (item) => item.properties.uuid !== uuid
      );
      this.props.set_value_toolbox({
        key: "features_area_center",
        value: features_area_center,
      });
    } else if (mode_toolbox === "features_isokron") {
      let { features_isokron_center, features_isokron } = this.props.toolbox;
      features_isokron_center = features_isokron_center.filter(
        (item) => item.properties.uuid !== uuid
      );
      features_isokron = features_isokron.filter(
        (item) => item.properties.uuid !== uuid
      );
      this.props.set_value_toolbox({
        key: "features_isokron_center",
        value: features_isokron_center,
      });
      this.props.set_value_toolbox({
        key: "features_isokron",
        value: features_isokron,
      });
    }

    const uuid_name = get_toolbox_mode_list(mode_toolbox).uuid_name || "";
    this.props.set_value_toolbox({
      key: uuid_name,
      value: "",
    });

    if (status && id !== "") {
      this.setState({
        option_isokron: {
          status: false,
          id: "",
        },
      });
    }
    this.props.status_toolbox();
  };

  on_select_uuid = (uuid) => {
    const { mode_toolbox } = this.props.toolbox;
    const uuid_name = get_toolbox_mode_list(mode_toolbox).uuid_name || "";
    this.props.set_value_toolbox({
      key: uuid_name,
      value: uuid,
    });

    if (uuid) {
      const feature = this.props.toolbox[mode_toolbox].find(
        (item) => item?.properties?.uuid === uuid
      );
      const geojson = {
        type: "FeatureCollection",
        features: [feature],
      };
      const feature_center = centroid(geojson);
      const longitude = feature_center?.geometry?.coordinates?.[0];
      const latitude = feature_center?.geometry?.coordinates?.[1];
      const { map_object } = this.props.layer;
      if (map_object && longitude && latitude) {
        map_object.flyTo({
          center: [longitude, latitude],
          speed: 1,
        });
      }
    }
  };

  handle_open_isokron_opt = (item) => {
    const { status, id } = this.state.option_isokron;
    if (item.properties.contour_type === "meters") {
      this.setState({ distance: true });
      this.setState({ data_new_isokron: { contour_type: "meters" } });
    } else {
      this.setState({ distance: false });
      this.setState({ data_new_isokron: { contour_type: "minutes" } });
    }
    if (!status && id === "") {
      this.setState({
        option_isokron: {
          status: true,
          id: item.properties.uuid,
        },
      });
    }
  };

  on_change_opt_isokron = (event) => {
    const key = event.target.name;
    const value = event.target.value;
    if (value === "meters") {
      this.setState({ distance: true });
    } else if (value === "minutes") {
      this.setState({ distance: false });
    }

    this.setState((prevState) => ({
      data_new_isokron: {
        ...prevState.data_new_isokron,
        [key]: value,
      },
    }));
  };

  handle_create_isokron = (data, item) => {
    const { status, id } = this.state.option_isokron;
    const { features_isokron_center } = this.props.toolbox;
    let feature = {
      ...item,
      properties: {
        ...item.properties,
        name: `I-${features_isokron_center.length + 1}`,
        isochrone_profile: data.isochrone_profile,
        contour_type: data.contour_type,
        contours_minutes: data.contours_minutes,
        contours_meters: data.contours_meters,
        uuid: generate_uuid(),
        color: st_colors[features_isokron_center.length % st_colors.length],
        center: item?.properties.center,
      },
      geometry: {
        ...item.geometry,
        coordinates: item?.properties.center,
      },
    };
    this.props.push_value_toolbox({
      key: "features_isokron_center",
      value: [feature],
    });
    this.props.generate_isokron(feature);
    if (status && id !== "") {
      this.setState({
        option_isokron: {
          status: false,
          id: "",
        },
      });
    }
  };

  handle_cancel_create_isokron = (data, item) => {
    const { status, id } = this.state.option_isokron;

    if (status && id !== "") {
      this.setState({
        option_isokron: {
          status: false,
          id: "",
        },
      });
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    // const { modal_default_radius, option_isokron, distance } = this.state;

    //global props
    const {
      mode_toolbox,
      // loading_status,
      // loading_item,
      // default_radius_km,
      // default_radius_m,
      // mode_draw,
      // elevation_chart_array
    } = this.props.toolbox;
    // const { draw_state_platform } = this.props.layer;
    const { domain } = this.props.auth;

    //content

    let mode_list = get_toolbox_mode_list()

    if (!domain_bbws_maluku_river_schema.includes(domain)) {
      mode_list = mode_list.filter((item) => item.key !== "river_schema");
    }

    // let features = [];
    // if (
    //   mode_toolbox !== "grouping" &&
    //   mode_toolbox !== "scoring_grids" &&
    //   mode_toolbox !== "river_schema"
    // ) {
    //   features = this?.props?.toolbox?.[mode_toolbox] || [];
    // }

    // const tool = get_toolbox_mode_list(mode_toolbox) || {};
    // let {
    //   uuid_name,
    //   // text_button, 
    //   // name_id 
    // } = tool;
    // const uuid_selected = this.props.toolbox[uuid_name];

    // let chart_item;
    // if (mode_toolbox === "features_elevation" && uuid_selected) {
    //   if (loading_status && loading_item === "generate_elevation") {
    //     chart_item = (
    //       <section className="container_light background_grey_light outline_black">
    //         <p className="text_bold">
    //           {dict?.["Measuring elevation"]?.[language]}...
    //         </p>
    //       </section>
    //     );
    //   } else {
    //     const { elevation_chart_array } = this.props.toolbox;
    //     const elevation_chart_item = elevation_chart_array.find(
    //       (item) => item.parent_uuid === uuid_selected
    //     );

    //     if (elevation_chart_item) {

    //       const chart_js_data = {
    //         labels: elevation_chart_item.labels,
    //         datasets: [
    //           {
    //             label: "Elevation chart",
    //             labels: elevation_chart_item.labels,
    //             data: elevation_chart_item.data,
    //             backgroundColor: "#0ca5eb",
    //           },
    //         ],
    //       };

    //       // chart_item = (
    //       //   <main className="container_light background_grey_light outline_black">
    //       //     <p className="text_bold margin_bottom">
    //       //       {dict?.["Elevation contour along cross section (m)"]?.[language]}
    //       //     </p>
    //       //     <section className="container_light background_grey_light outline_black">
    //       //       <CHART_TEMPLATE
    //       //         type="line"
    //       //         height={200}
    //       //         style={{
    //       //           width: "100%",
    //       //         }}
    //       //         options={{
    //       //           hoverBackgroundColor: "#000000",
    //       //           animation: false,
    //       //           maintainAspectRatio: false,
    //       //           responsive: false,
    //       //           legend: {
    //       //             display: false,
    //       //           },
    //       //           indexAxis: "x",
    //       //           title: {
    //       //             display: false,
    //       //           },
    //       //           plugins: {
    //       //             legend: {
    //       //               display: false,
    //       //             },
    //       //           },
    //       //         }}
    //       //         data={chart_js_data}
    //       //         use_legend={false}
    //       //         use_generate_array_color={false}
    //       //       />
    //       //     </section>
    //       //   </main>
    //       // );
    //     }

    //   }
    // }

    // let button_create_content;
    // if (draw_state_platform === "toolbox" && mode_draw !== "simple_select") {
    //   //DISABLE BUTTON
    //   button_create_content = (
    //     <button
    //       className="button_pill background_grey margin_bottom"
    //       style={{ whiteSpace: "break-spaces" }}
    //     >
    //       <span className="badge_circle background_white">+</span>{" "}
    //       {` START DRAW ON MAP  `}
    //     </button>
    //   );
    // } else if (loading_status && loading_item === "generate_elevation") {
    //   //LOADING ELEVATION
    //   button_create_content = (
    //     <button
    //       className="button_pill background_grey margin_bottom"
    //       style={{ whiteSpace: "break-spaces" }}
    //     >
    //       <span className="badge_circle background_white">+</span>{" "}
    //       {` GET ELEVATION DATA...  `}
    //     </button>
    //   );
    // } else if (mode_toolbox === "grouping") {
    //   //MODE GROUPING ELEVATION
    //   button_create_content = (
    //     <button
    //       className="button_pill background_grey margin_bottom"
    //       style={{ whiteSpace: "break-spaces" }}
    //     >
    //       <span className="badge_circle background_white">+</span>{" "}
    //       {` GROUPING ISOCHRONE ACTIVATED  `}
    //     </button>
    //   );
    // }
    // else {
    //   //ACTIVE FOR START DRAW
    //   button_create_content = (
    //     <button
    //       className="button_pill background_black margin_bottom"
    //       onClick={this.on_draw}
    //       style={{ whiteSpace: "break-spaces" }}
    //       data-mapid="clickDraw"
    //     >
    //       <span className="badge_circle background_white">+</span>{" "}
    //       {` ${text_button}  `}
    //     </button>
    //   );
    // }

    const general_toolbox = (
      <main>
        {
          mode_toolbox === "" ? (
            <div>
              <section style={{ padding: "30px 27px 0 27px" }}>
                <span style={{ fontSize: "18px", fontWeight: 700 }}>MAP Analysis Tools</span>
                <p style={{ fontSize: "14px", marginTop: "10px" }}>{dict["Measure distance, check elevation, draw areas, or find routes easily."][language]}</p>
              </section>

              <section style={{ margin: "30px 0 30px 0" }} className="center_perfect">
                <TOOLBOX_SELECTION
                  name="mode_toolbox"
                  value={mode_toolbox}
                  tools={mode_list}
                />
              </section>
            </div>
          ) : mode_toolbox === "features_radius" ? (
            <TOOLBOX_DETAIL_RADIUS />
          ) : mode_toolbox === "features_area" ? (
            <TOOLBOX_DETAIL_AREA />
          ) : mode_toolbox === "features_distance" ? (
            <TOOLBOX_DETAIL_DISTANCE />
          ) : mode_toolbox === "features_elevation" ? (
            <TOOLBOX_DETAIL_ELEVATION />
          ) : mode_toolbox === "features_isochrone" ? (
            <TOOLBOX_DETAIL_ISOCHRONE />
          ) : mode_toolbox === "features_routing" ? (
            <TOOLBOX_DETAIL_ROUTING />
          ) : (
            <></>
          )
        }
      </main>
    );

    let content;

    if (mode_toolbox === "scoring_grids") {
      content = <TOOLBOX_GRID />;
    } else if (mode_toolbox === "river_schema") {
      content = <TOOLBOX_RIVER_SCHEMA />;
    } else if (mode_toolbox === "gap") {
      content = <GAP_TOOL />;
    } else {
      content = general_toolbox;
    }

    return <main>{content}</main>;
  }
}

const mapStateToProps = (state) => ({
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  auth: state.auth,
  insight_reducer: state.insight_reducer
});

export default connect(mapStateToProps, {
  set_value_toolbox,
  set_value_layer,
  change_radius,
  set_value_sini,
  push_value_toolbox,
  generate_isochrone,
  status_action,
  status_toolbox,
  get_list_tipe_1,
  get_list_tipe_2,
  get_list_tipe_3
})(TOOLBOX_TABLE);
